"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddLayerElementFactoryContext = exports.GlobalFiltersElementFactoryContext = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const R = react_1.default.createElement;
const MWaterTableSelectComponent_1 = __importDefault(require("./mwater_table_selection/MWaterTableSelectComponent"));
const MWaterAddRelatedFormComponent_1 = __importDefault(require("./MWaterAddRelatedFormComponent"));
const MWaterAddRelatedIndicatorComponent_1 = __importDefault(require("./MWaterAddRelatedIndicatorComponent"));
const MWaterGlobalFiltersComponent_1 = __importDefault(require("./MWaterGlobalFiltersComponent"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const expressions_ui_2 = require("@mwater/expressions-ui");
exports.GlobalFiltersElementFactoryContext = (0, react_1.createContext)(null);
exports.AddLayerElementFactoryContext = (0, react_1.createContext)(undefined);
/**
 * Creates several contexts to allow selecting of a table in an mWater-friendly way
 * and several other context items
 */
class MWaterContextComponent extends react_1.default.Component {
    createTableSelectElementFactory = (options) => {
        return (react_1.default.createElement(MWaterTableSelectComponent_1.default, { apiUrl: this.props.apiUrl, client: this.props.client, schema: options.schema, user: this.props.user, table: options.value ?? undefined, onChange: options.onChange, extraTables: this.props.extraTables, onExtraTablesChange: this.props.onExtraTablesChange, filter: options.filter, onFilterChange: options.onFilterChange }));
    };
    createGlobalFiltersElementFactory = (props) => {
        if (props.nullIfIrrelevant && !lodash_1.default.any(props.filterableTables, (t) => t.match(/^entities./))) {
            return null;
        }
        return react_1.default.createElement(MWaterGlobalFiltersComponent_1.default, { ...props });
    };
    isScalarExprTreeSectionMatch = (options) => {
        if (options.tableId.match(/^entities\./) && options.section.id === "!indicators") {
            return true;
        }
        return null;
    };
    isScalarExprTreeSectionInitiallyOpen = (options) => {
        return false;
    };
    decorateScalarExprTreeSectionChildren = (options) => {
        // If related forms section of entities table or assets table
        if (options.tableId.match(/^entities\./) && options.section.id === "!related_forms") {
            return R("div", { key: "_add_related_form_parent" }, options.children, R(MWaterAddRelatedFormComponent_1.default, {
                key: "_add_related_form",
                table: options.tableId,
                apiUrl: this.props.apiUrl,
                client: this.props.client,
                user: this.props.user,
                schema: this.props.schema,
                onSelect: this.handleAddTable
            }));
        }
        // If indicators section of entities table
        if (options.tableId.match(/^entities\./) && options.section.id === "!indicators") {
            return R("div", { key: "_add_related_indicator_parent" }, options.children, R(MWaterAddRelatedIndicatorComponent_1.default, {
                key: "_add_related_indicator",
                table: options.tableId,
                apiUrl: this.props.apiUrl,
                client: this.props.client,
                user: this.props.user,
                schema: this.props.schema,
                onSelect: this.handleAddTable,
                filter: options.filter
            }));
        }
        else {
            return options.children;
        }
    };
    handleAddTable = (table) => {
        const extraTables = lodash_1.default.union(this.props.extraTables || [], [table]);
        return this.props.onExtraTablesChange(extraTables);
    };
    render() {
        return react_1.default.createElement(expressions_ui_1.CustomTableSelectComponentFactoryContext.Provider, { value: this.createTableSelectElementFactory },
            react_1.default.createElement(exports.GlobalFiltersElementFactoryContext.Provider, { value: this.createGlobalFiltersElementFactory },
                react_1.default.createElement(expressions_ui_2.IsScalarExprTreeSectionMatchContext.Provider, { value: this.isScalarExprTreeSectionMatch },
                    react_1.default.createElement(expressions_ui_2.IsScalarExprTreeSectionInitiallyOpenContext.Provider, { value: this.isScalarExprTreeSectionInitiallyOpen },
                        react_1.default.createElement(expressions_ui_1.DecorateScalarExprTreeSectionChildrenContext.Provider, { value: this.decorateScalarExprTreeSectionChildren },
                            react_1.default.createElement(exports.AddLayerElementFactoryContext.Provider, { value: this.props.addLayerElementFactory }, this.props.children))))),
            "    ");
    }
}
exports.default = MWaterContextComponent;
